import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProfileSelectors } from '@grandvisionhq/my-account';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import { CheckoutForm } from '../../../../components/Forms/CheckoutForm.js';
import { FormFieldsWithCart } from '../../../../components/FormFieldsWithCart/FormFieldsWithCart.js';
import { useIsFormSlotAvailable } from '../../../../slots/forms/form-context.js';
import '../../../../slots/summaries/summary-context.js';
import '../../../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../../../state.js';
import { updateShippingDetails } from '../../../../StepShipping/actions.js';
import { getExpressCheckoutFormData } from '../../../../StepShipping/selectors.js';

const ExpressCheckoutFormContainer = ()=>{
    var ref, ref1;
    const dispatch = useDispatch();
    const isExpressFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.ExpressCheckout);
    const expressCheckoutInitialData = useSelector(getExpressCheckoutFormData);
    const profileDateOfBirthValue = (ref = useSelector(ProfileSelectors.getFormData)) === null || ref === void 0 ? void 0 : (ref1 = ref.personalDetails) === null || ref1 === void 0 ? void 0 : ref1.dateOfBirth;
    const initialExpressCheckoutData = React.useMemo(()=>{
        const expressCheckoutDOBKey = 'express-checkout-dob';
        const dobFormData = expressCheckoutInitialData === null || expressCheckoutInitialData === void 0 ? void 0 : expressCheckoutInitialData[expressCheckoutDOBKey];
        if (dobFormData && profileDateOfBirthValue) {
            return swcHelpers.objectSpread({}, expressCheckoutInitialData, {
                [expressCheckoutDOBKey]: swcHelpers.objectSpread({}, dobFormData, {
                    value: dobFormData.value || profileDateOfBirthValue
                })
            });
        }
        return expressCheckoutInitialData;
    }, [
        expressCheckoutInitialData,
        profileDateOfBirthValue
    ]);
    const handleChange = React.useCallback((formData)=>{
        dispatch(updateShippingDetails({
            form: formData
        }));
    }, [
        dispatch
    ]);
    if (!isExpressFormAvailable) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "express-checkout-form-container"
    }, /*#__PURE__*/ React.createElement(CheckoutForm, {
        formName: "expressCheckout",
        "data-t": "expressCheckout",
        initialFormState: initialExpressCheckoutData,
        onChange: handleChange
    }, /*#__PURE__*/ React.createElement(FormFieldsWithCart, {
        formName: ShippingObjectTypes.ExpressCheckout
    })));
};

export { ExpressCheckoutFormContainer };
//# sourceMappingURL=ExpressCheckoutFormContainer.js.map
